import { render } from "./UploadBox.vue?vue&type=template&id=648a23c4&scoped=true&ts=true"
import script from "./UploadBox.vue?vue&type=script&lang=ts"
export * from "./UploadBox.vue?vue&type=script&lang=ts"

import "./UploadBox.vue?vue&type=style&index=0&id=648a23c4&scoped=true&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648a23c4"]])

export default __exports__